// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"ea5cf8e3","787":"a1172d03","820":"2658e8c6"}[chunkId] + ".chunk.js";
};